import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Button, Modal, ModalBody } from 'reactstrap';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import './GetStarted.scss';

class GetStarted extends Component {
  constructor(props) {
    super(props);
    this.state= {
      modalOpen: false
    };

    this.clickGetStarted = this.clickGetStarted.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
  }
  onClickForward() {
    this.props.history.replace('/RatesFees');
  }
  clickGetStarted(event) {
    event.preventDefault();
    this.setState({
      modalOpen: true
    });
  }
  closeModal() {
    this.setState({
      modalOpen: false
    });
  }
  toggle() {
    this.setState({
      modalOpen: !this.state.modalOpen
    });
  }
  onClickBackward() {
    if(this.props.offerCode.startedWithOfferCode) {
      let currentCode = this.props.offerCode.offerCode;
      this.props.history.replace('/Card/'+this.props.card.tpc+'/'+this.props.card.cpc+'/'+currentCode);
    }
    else {
      this.props.history.replace('/');
    }
  }
  render() {
    console.log(window.location.pathname)
    const modalCloseButton = <div className="close-modal" onClick={this.closeModal}></div>
    let fragment;    

    if (this.props.card.cpc === "VIR") {
      fragment =
        <div>
          <li>Meet at least one of the following:</li>
          <ul className="ul-regular-list">
            <li className="regular-list">Minimum annual personal income of $60,000</li>
            <li className="regular-list">
              Minimum annual household income of $100,000
              <br />
              <span className="small-font">(Includes the total combined income, before taxes and deductions, of all members within a household)</span>
            </li>
            <li className="regular-list">
              Investable funds of $250,000 or more
              <br />
              <span className="small-font">(Includes the money saved in your chequing and savings accounts, and the total market value of your RRSP, TFSA or other investment accounts at Vancity and other financial institutions)</span>
            </li>
          </ul>
        </div>
        
    } else if (this.props.card.cpc === "VPR") {
      fragment =
        <div>
          <li>Meet at least one of the following:</li>
          <ul className="ul-regular-list">
          <li className="regular-list">Minimum annual personal income of $150,000</li>
            <li className="regular-list">
              Minimum annual household income of $200,000
              <br />
              <span className="small-font">(Includes the total combined income, before taxes and deductions, of all members within a household)</span>
            </li>
            <li className="regular-list">
              Investable funds of $400,000 or more
              <br />
              <span className="small-font">(Includes the money saved in your chequing and savings accounts, and the total market value of your RRSP, TFSA or other investment accounts at Vancity and other financial institutions)</span>
            </li>
          </ul>
        </div>        
    }

    
    return (
      <div className="get-started">    
        <h1>Let’s get started</h1>
        <p className="heading">We want to ensure you understand and agree with the details of your credit card application.</p>
        <p className="heading">First, we’ll review the fees and important information associated with your card.</p>
        <Form onSubmit={this.clickGetStarted}>
          <div className="button-background">
            <Button color="primary" type="submit" size="lg" onClick={this.clickGetStarted}>Get started</Button>
            <Button color="link" className="back" onClick={this.onClickBackward}>Previous</Button>
          </div>
        </Form>
        <Modal isOpen={this.state.modalOpen} toggle={this.toggle} centered={true} className="get-started-modal" modalClassName="get-started" external={modalCloseButton}>
          <div className="close-modal mobile" onClick={this.closeModal}></div>
          <ModalBody>                
            <h1>Are you eligible for a Vancity {this.props.card.name}?</h1>            
            <p>To be eligible, you must:</p>
            <ul>
              <li>Be at least 19 years or older.</li>
              <li>Live in British Columbia and have a BC address.</li>
              <li>Have previous credit history.</li>
              <li>Not have declared bankruptcy in the last 7 years.</li>
              {fragment}
            </ul>
            <hr />
            <p>If you've recently moved to Canada, have no previous credit history or have declared bankruptcy in the last seven years, please call us at <PhoneNumber value="604-871-5435" /> or toll-free at <PhoneNumber value="1-888-821-5435" />.</p>
            <div className="button-container">
                <Button color="primary" size="lg" onClick={this.onClickForward}>Got it</Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  card: state.card,
  startedWithOfferCode: state.startedWithOfferCode,
  offerCode: state.offerCode,
 
})

export default connect(mapStateToProps)(withBackgroundImage("get-started")(GetStarted));


// WEBPACK FOOTER //
// ./src/containers/GetStarted/GetStarted.js